"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoadMoreMedia = void 0;
var _presentationHttp = require("@ori/presentation-http");
var _react = require("react");
var _models = require("../models");
var _utils = require("../utils");
var _externalUrl = require("./externalUrl");
/* istanbul ignore file @preserve --api */

const fetchMedia = async ({
  mediaUrl
}) => (0, _externalUrl.getExternalUrl)(mediaUrl, {
  responseType: 'json'
});
const getMedia = async ({
  mediaUrl
}) => {
  const response = await fetchMedia({
    mediaUrl
  });
  return (0, _presentationHttp.validateResponse)(response, {
    schema: _models.olapicResponseMediaSchema,
    onError: () => ({
      loadMoreUrl: '',
      mediaItems: []
    }),
    onSuccess: ({
      data
    }) => {
      const result = data.data;
      const items = result._embedded.media.map(_utils.createMediaItem);
      return {
        loadMoreUrl: result._links.next?.href ?? '',
        mediaItems: items
      };
    }
  });
};
const useLoadMoreMedia = () => {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const getMediaItems = (0, _react.useCallback)(async mediaUrl => {
    setIsLoading(true);
    const response = await getMedia({
      mediaUrl
    });
    setIsLoading(false);
    return response;
  }, []);
  return {
    getMediaItems,
    isLoading
  };
};
exports.useLoadMoreMedia = useLoadMoreMedia;
